module.exports = __webpack_public_path__ + "static/media/calender.ed1a50b5.svg";